import { ServerConfig } from "@/config/config";
import { createSocketService } from "@/utils/socket-service-factory";

export const AuthSocketService = createSocketService(ServerConfig.hostSocket, "/socket.io/admin/");